<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="3">
        <ShowcaseList></ShowcaseList>
      </v-col>
      <v-col cols="9">
        <ShowcaseDetails :showcase="getShowcase"></ShowcaseDetails>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShowcaseDetails from './ShowcaseDetails'
import ShowcaseList from './ShowcaseList'
import { DOMAIN_NAME } from '@/domain/showcases'
import { GET_SHOWCASE } from '../constants/query'
export default {
  name: 'Showcase',
  components: {
    ShowcaseDetails,
    ShowcaseList
  },
  apollo: {
    $client: DOMAIN_NAME,
    getShowcase: {
      query: GET_SHOWCASE,
      variables() {
        return { showcaseId: this.$route.params.id }
      },
      skip() {
        return !this.$route.params.id
      },
      error(error) {
        this.getShowcaseErrors = JSON.stringify(error.message)
      }
    }
  },
  data: () => ({
    getShowcase: null,
    getShowcaseErrors: null
  })
}
</script>

<style scoped></style>
